import React, {useContext} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import Flag from 'react-world-flags';
import {LanguageContext} from './LanguageContext';

const LanguageSwitch = ({color = "inherit", size = "medium", sx = {}}) => {
    const {translations, switchLanguage, language} = useContext(LanguageContext);

    // Map language codes to country codes for flags
    const getCountryCode = (lang) => {
        switch (lang) {
            case 'sr':
                return 'RS'; // Serbia
            case 'en':
                return 'GB'; // United Kingdom
            case 'sl':
                return 'SI'; // Slovenia
            default:
                return 'RS';
        }
    };

    // Get language display name
    const getLanguageName = (lang) => {
        switch (lang) {
            case 'sr':
                return 'Srpski';
            case 'en':
                return 'English';
            case 'sl':
                return 'Slovenščina';
            default:
                return 'Srpski';
        }
    };

    const iconSize = size === "small" ? 16 : size === "large" ? 28 : 20;

    return (
        <Tooltip title={`${translations?.switchLanguage || "Switch Language"} (${getLanguageName(language)})`}>
            <IconButton
                onClick={switchLanguage}
                color={color}
                sx={{
                    p: 1,
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        transform: 'scale(1.05)',
                    },
                    ...sx
                }}
            >
                <Flag
                    code={getCountryCode(language)}
                    style={{
                        width: iconSize,
                        height: iconSize,
                        borderRadius: '4px',

                    }}
                />
            </IconButton>
        </Tooltip>
    );
};

export default LanguageSwitch;